import { httpMethods } from 'enums';
import { Http } from 'library';
import api from 'api/client';

import * as Endpoints from 'constants/endpoints.constant';

class SipHttp {
  async getSIPList(data: any, userId: any) {
    const newdata = { ...data, user_id: userId };
    return await Http.setMethod(httpMethods.post)
      .setUrl(`${Endpoints.GET_SIP_LIST}`)
      .setData(newdata)
      .setToken(api.getToken())
      .request();
  }
  async createSIPWithEM(customerId: any, userId: any, isUpi: any,frequency:any) {
    return await Http.setMethod(httpMethods.post)
      .setUrl(
        `${Endpoints.WITH_EM}?customerId=${customerId}&user_id=${userId}&isupi=${isUpi}&frequency=${frequency}`
      )

      .setToken(api.getToken())
      .request();
  }
  async createSIPWithoutEM(customerId: any, data: any) {
    const sipData = { data: data };
    return await Http.setMethod(httpMethods.post)
      .setUrl(`${Endpoints.WITHOUT_EM}?customerId=${customerId}`)
      .setData(sipData)
      .setToken(api.getToken())
      .request();
  }

  async getEmandatesList(query: any, customerId: any) {
    return await Http.setMethod(httpMethods.get)
      .unsetData()
      .setUrl(`${Endpoints.GET_EMANDATE_LIST}?${query}`)
      .setToken(api.getToken())
      .request();
  }

  async changeEmandateStatus(data: any) {
    return await Http.setMethod(httpMethods.put)
      .setUrl(`${Endpoints.CANCEL_EMANDATE}`)
      .setData(data)
      .setToken(api.getToken())
      .request();
  }
  async getUpcomingList(query: any) {
    return await Http.setMethod(httpMethods.get)
      // .setUrl(`${Endpoints.GET_UPCOMING_LIST}?sip_id=eb-s-000009`)
      .unsetData()
      .setUrl(`${Endpoints.GET_UPCOMING_LIST}?${query}`)
      .setToken(api.getToken())
      .request();
  }
  async getCompletedList(query: any) {
    return await Http.setMethod(httpMethods.get)
      // .setUrl(`${Endpoints.GET_SCHEDULE_LIST}?sip_id=eb-s-000015`)
      .setUrl(`${Endpoints.GET_SCHEDULE_LIST}?${query}`)
      .setToken(api.getToken())
      .request();
  }
  async changeSIPStatus(data: any) {
    return await Http.setMethod(httpMethods.put)
      .setUrl(`${Endpoints.CHANGE_SIP_STATUS}`)
      // .setUrl(`${Endpoints.GET_SCHEDULE_LIST}?${query}`)
      .setData(data)
      .setToken(api.getToken())
      .request();
  }

  async payNowBtnFunc(sipId: any) {
    return await Http.setMethod(httpMethods.get)
      .setUrl(`${Endpoints.PAY_NOW_BUTTON}?sip_id=${sipId}`)
      // .setUrl(`${Endpoints.GET_SCHEDULE_LIST}?${query}`)
      .setToken(api.getToken())
      .request();
  }
  async getMetalRates() {
    return await Http.setMethod(httpMethods.get)
      .setUrl(`${Endpoints.GET_METAL_RATES}`)
      // .setUrl(`${Endpoints.GET_SCHEDULE_LIST}?${query}`)
      .setToken(api.getToken())
      .request();
  }

  async checkThreshold(data: any) {
    return await Http.setMethod(httpMethods.post)
      .setUrl(`${Endpoints.CHECK_THRESHOLD}`)
      .setData(data)
      .setToken(api.getToken())
      .request();
  }

  async createDailySIPWithEM(data) {
    return await Http.setMethod(httpMethods.post)
      .setUrl(`${Endpoints.DAILY_SIP_WITH_EM}`)
      .setData(data)
      .setToken(api.getToken())
      .request();
  }
  async createDailySIPStatus(data) {
    return await Http.setMethod(httpMethods.post)
      .setUrl(`${Endpoints.DAILY_SIP_GET_STATUS}`)
      .setData(data)
      .setToken(api.getToken())
      .request();
  }
}

export default new SipHttp();
